<template>
  <div
    v-if="totalPages > 0"
    class="match-pagination"
    :class="{ 'match-pagination--large': size === 'large' }"
  >
    <div
      class="pagination-control previous"
      :class="{ disabled: currentPage === 1 }"
      @click="changePage(currentPage - 1)"
    >
      上一页
    </div>
    <div
      v-for="page in totalPages"
      :key="page"
      class="pagination-page"
      :class="{ active: currentPage === page }"
      @click="changePage(page)"
    >
      {{ page }}
    </div>
    <div
      class="pagination-control next"
      :class="{ disabled: currentPage === totalPages }"
      @click="changePage(currentPage + 1)"
    >
      下一页
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchPagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    size: {
      type: String,
      default: 'default',
      validator: value => ['default', 'large'].includes(value),
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return
      this.$emit('change', page)
    },
  },
}
</script>

<style scoped lang="scss">
.match-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.135417rem;
  margin-top: 0.15625rem;
  color: #000000;
  font-size: 0.0625rem;
  line-height: 0.135417rem;

  .pagination-control,
  .pagination-page {
    height: 0.135417rem;
    line-height: 0.135417rem;
    text-align: center;
  }

  .pagination-control {
    width: 0.333333rem;
    cursor: pointer;

    &.disabled {
      cursor: default;
    }
  }

  .previous {
    background: rgba(60, 86, 113, 0.5);
  }

  .next {
    background: rgba(60, 86, 113, 0.2);
  }

  .pagination-page {
    width: 0.135417rem;
    margin: 0 0.026042rem;
    color: #4e4e4e;
    cursor: pointer;

    &.active {
      background: rgba(60, 86, 113, 0.2);
      color: #2f2f2f;
    }
  }

}

@media (min-width: 751px) {
  .match-pagination.match-pagination--large {
    height: 0.166667rem;
    margin-top: 0.182292rem;
    font-size: 0.083333rem;
    line-height: 0.166667rem;

    .pagination-control,
    .pagination-page {
      height: 0.166667rem;
      line-height: 0.166667rem;
    }

    .pagination-control {
      width: 0.416667rem;
    }

    .pagination-page {
      width: 0.166667rem;
      margin: 0 0.03125rem;
    }
  }
}

@media (max-width: 750px) {
  .match-pagination {
    height: auto;
    margin-top: 4vw;
    font-size: 2.8vw;
    line-height: 7vw;

    .pagination-control,
    .pagination-page {
      height: 7vw;
      line-height: 7vw;
      border-radius: 1vw;
    }

    .pagination-control {
      width: 14vw;
    }

    .pagination-page {
      width: 7vw;
      margin: 0 1vw;
    }
  }
}
</style>
